<template>
<div class="white">
  <v-content>
    <section>
      <v-parallax :src="require('@/app/assets/images/nature40.jpg')" height="600">
        <v-layout row class="mt-4">
          <div :class="ui.textDisplay1Light"> {{this.companyTitle2}} </div>
          <v-spacer/>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/signin'">
              <v-icon dark>person</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/signin'">
              <v-icon dark left>person</v-icon>
              sign in
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" :to="'/signup'">
              <v-icon dark>person_add</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/signup'">
              <v-icon dark left>person_add</v-icon>
              sign up
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/about'">
              <v-icon dark left>info_outline</v-icon>
              about
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" :to="'/about'">
              <v-icon dark>info_outline</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" href="https://www.besea.com.au">
              <v-icon dark left>public</v-icon>
              besea
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" href="https://www.besea.com.au">
              <v-icon dark>public</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Pilbara, Western Australia </div>
      </v-layout>
    </section>

    <section>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm10 lg6 offset-xs0 offset-sm1 offset-lg3>
          <span :class="ui.textHeadline">
            {{this.companyDescription1}}
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard1"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard2"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard3"/>
        </v-flex>
      </v-layout>
    </section>
    <section>
      <v-parallax :src="require('@/app/assets/images/nature12.jpg')" height="500">
        <v-layout row align-top class="mt-4">
          <div :class="ui.textDisplay1Light"> low carbon low cost </div>
          <v-spacer/>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/commercial'">
              <v-icon dark>emoji_food_beverage</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/commercial'">
              <v-icon dark left>
                emoji_food_beverage
              </v-icon>
              plans
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Shire of Carnarvon, Western Australia </div>
      </v-layout>
    </section>

    <section>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm10 lg6 offset-xs0 offset-sm1 offset-lg3>
          <span :class="ui.textHeadline">
            {{this.companyDescription4}}
          </span>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard4"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard5"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard6"/>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax :src="require('@/app/assets/images/ship02.jpg')" height="500">
        <v-layout column align-center justify-center>
          <div :class="ui.textDisplay2Light"> {{this.companyTitle2}} </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Indian Ocean </div>
      </v-layout>
    </section>

    <section>
      <ContactInfo/>
    </section>

    <PublicFooterPage/>

  </v-content>
</div>
</template>

<script>
import InfoCard from "../components/InfoCard";
import ContactInfo from "../components/ContactInfo";
import PublicFooterPage from "../components/PublicFooterPage";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";

export default {
  components: {
    ContactInfo,
    InfoCard,
    PublicFooterPage
  },
  mixins: [apptheme, publicGlobals],
  data() {
    return {
      currentPagePath: "/",
      InfoCard1: {
        title: "Plan",
        icon: "event",
        // eslint-disable-next-line
        text: "Plan budget and execution activities taking into account resources, time and carbon constraints. Release approved plans to all facility end users."
      },
      InfoCard2: {
        title: "Operate",
        icon: "notifications",
        // eslint-disable-next-line
        text: "Ensure safe, reliable and sustainable operations through facility notifications and inspection routines. Report incidents and machine underperformance."
      },
      InfoCard3: {
        title: "Safety",
        icon: "health_and_safety",
        // eslint-disable-next-line
        text: "Maintain system hazard and incident register. Communicate to the work force new or updated facility operational risks and asset access restrictions."
      },
      InfoCard4: {
        title: "Carbon",
        icon: "co2",
        // eslint-disable-next-line
        text: "Measure and monitor facility carbon footprint, project resources and maintenance costs. Adjust vendor register or maintenance scope to optimise emissions and cost."
      },
      InfoCard5: {
        title: "Maintenance",
        icon: "build",
        // eslint-disable-next-line
        text: "Design maintenance strategies with failure mode analysis for each equipment type. Generate preventative maintenance work requests for multiple assets."
      },
      InfoCard6: {
        title: "Decision",
        icon: "touch_app",
        // eslint-disable-next-line
        text: "Enable planning, strategic and operational decisions where costs, inspection and test results for projects and maintenance activities can be reviewed in real time."
      }
    };
  }
};
</script>
